import Embed from "@editorjs/embed";
import Header from "@editorjs/header";
export const configIconDesc = [
  {
    en: "This is a quote indication calculated on Quotey. If you want to bind, you can make the request through Quotey. The insurer will review and confirm the bind in due course.",
    fr: "Il s'agit d'une indication de devis calculée sur Quotey. Si vous souhaitez lier, vous pouvez faire la demande via Quotey. L'assureur examinera et confirmera le lien en temps voulu.",
  },
  {
    en: "This is a bindable quote calculated on Quotey. You can send to the insurer and ask them to bind.",
    fr: "Il s'agit d'un devis liant calculé sur Quotey. Vous pouvez l'envoyer à l'assureur et lui demander de lier.",
  },
  {
    en: "This is a quote indication calculated on Quotey. If you want to bind, you will need to quote and bind in the insurer's portal.",
    fr: "Il s'agit d'une indication de devis calculée sur Quotey. Si vous souhaitez lier, vous devrez obtenir un devis et lier via le portail de l'assureur.",
  },
  {
    en: "This is a bindable quote calculated on Quotey. In order to bind, you will need to add to the insurer's portal.",
    fr: "Il s'agit d'un devis liant calculé sur Quotey. Pour lier, vous devrez ajouter via le portail de l'assureur.",
  },
  {
    en: "This is a bindable quote generated by this insurer. You will be able to request an instant bind on Quotey and the policy will also appear in the insurer's system.",
    fr: "Il s'agit d'un devis liant généré par cet assureur. Vous pourrez demander une liaison instantanée sur Quotey et la police apparaîtra également dans le système de l'assureur.",
  },
  {
    en: "This is a bindable quote generated by this insurer. You will be able to request an instant bind on Quotey and the policy will also appear in the insurer's system.",
    fr: "Il s'agit d'un devis liant généré par cet assureur. Vous pourrez demander une liaison instantanée sur Quotey et la police apparaîtra également dans le système de l'assureur.",
  },
  {
    en: "This is a bindable quote generated on Quotey. You will be able to bind and instantly issue documents through Quotey.",
    fr: "Il s'agit d'un devis liant généré sur Quotey. Vous pourrez lier et émettre instantanément des documents via Quotey.",
  },
  {
    en: "This quote was generated manually by the insurer and sent to you. You can request the bind through the underwriter.",
    fr: "Ce devis a été généré manuellement par l'assureur et vous a été envoyé. Vous pouvez demander la liaison via le souscripteur.",
  },
  {
    en: "Pending Underwriter Review",
    fr: "En attente d'examen par le souscripteur",
  },
  {
    en: "This should be a dark colour as it will have white font overlayed onto it. Ideally this will be your brokerage's primary brand colour.",
    fr: "Cela devrait être une couleur foncée car elle aura une police blanche superposée. Idéalement, ce sera la couleur principale de votre marque de cabinet.",
  },
  {
    en: "This should be an accent colour and will be displayed against white background, primarily used in headings.",
    fr: "Cela devrait être une couleur d'accentuation et sera affichée sur un fond blanc, principalement utilisée dans les titres.",
  },
  {
    en: "This should be a secondary accent colour and will be displayed against white background, primarily used in headings, tables and text.",
    fr: "Cela devrait être une couleur d'accentuation secondaire et sera affichée sur un fond blanc, principalement utilisée dans les titres, les tableaux et le texte.",
  },
];

export const BMS_ARRAY = [
  "EPIC",
  "TAM",
  "ACTURIS",
  "CSS",
  "SIG",
  "RPM",
  "POWERBROKER",
];

export const EDITOR_JS_TOOLS = {
  embed: Embed,
  header: Header,
};

export const termsText = {
  en: `<p><b>Software End User Licence Agreement</b></p>
<p>This End User Licence Agreement (this <b>"Agreement"</b>) is a binding agreement between Quotey, Inc. (<b>"Licensor"</b>) and you as the licensee of the Software (<b>"Licensee"</b>).</p>
<p>LICENSOR PROVIDES THE SOFTWARE SOLELY ON THE TERMS AND CONDITIONS SET FORTH IN THIS AGREEMENT AND ON THE CONDITION THAT LICENSEE ACCEPTS AND COMPLIES WITH THEM. BY CLICKING THE "ACCEPT" BUTTON YOU (A) ACCEPT THIS AGREEMENT AND AGREE THAT LICENSEE IS LEGALLY BOUND BY ITS TERMS; AND (B) REPRESENT AND WARRANT THAT: (I) YOU ARE OF LEGAL AGE TO ENTER INTO A BINDING AGREEMENT; AND (II) IF LICENSEE IS A CORPORATION, GOVERNMENTAL ORGANIZATION, OR OTHER LEGAL ENTITY, YOU HAVE THE RIGHT, POWER, AND AUTHORITY TO ENTER INTO THIS AGREEMENT ON BEHALF OF LICENSEE AND BIND LICENSEE TO ITS TERMS. IF LICENSEE DOES NOT AGREE TO THE TERMS OF THIS AGREEMENT, LICENSOR WILL NOT AND DOES NOT LICENCE THE SOFTWARE TO LICENSEE AND YOU MUST NOT USE THE SOFTWARE.</p>
<p>NOTWITHSTANDING ANYTHING TO THE CONTRARY IN THIS AGREEMENT OR YOUR OR LICENSEE'S ACCEPTANCE OF THE TERMS AND CONDITIONS OF THIS AGREEMENT, NO LICENCE IS GRANTED (WHETHER EXPRESSLY, BY IMPLICATION OR OTHERWISE) UNDER THIS AGREEMENT, AND THIS AGREEMENT EXPRESSLY EXCLUDES ANY RIGHT CONCERNING ANY SOFTWARE THAT LICENSEE DID NOT ACQUIRE LAWFULLY OR THAT IS NOT A LEGITIMATE, AUTHORIZED COPY OF LICENSOR'S SOFTWARE.</p>
<ol>
  <li>
    <p>Definitions. For purposes of this Agreement, the following terms have the following meanings:</p>
    <ol>
      <li>
        <p><b>"Intellectual Property Rights"</b> means any and all registered and unregistered rights granted, applied for, or otherwise now or hereafter in existence under or related to any patent, copyright,
        trademark, trade secret, database protection, or other intellectual property rights laws, and all similar or equivalent rights or forms of protection, in any part of the world.</p>
      </li>
      <li>
        <p><b>"Representative"</b> means, with respect to a party, that party's employees, officers, directors, consultants, agents, independent contractors, service providers, sublicensees, subcontractors, and legal advisors.&nbsp;</p>
      </li>
      <li>
        <p><b>"Software"</b> means the software programs Licensor provides to Licensee.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Access and Use.</u> Subject to and conditioned on Licensee’s compliance with the terms and conditions of this Agreement, Licensor hereby grants Licensee a non-exclusive, non-transferable right to access and use the Software during the Term, solely for use by Licensee in accordance with the terms and conditions herein. Such use is limited to Licensee’s internal use.</p>
  </li>
  <li>
    <p><u>Third-Party Materials.</u> The Software includes software, content, data, or other materials, including related documentation, that are owned by persons other than Licensor and that are provided to Licensee on licensee terms that are in addition to and/or different from those contained in this Agreement (<b>"Third-Party Licences"</b>). Ownership of all Intellectual Property Rights in such Third-Party Materials remains with the respective owners thereof. Licensee is bound by and shall comply with all Third-party Licences. Any breach by Licensee of any Third-party Licence is also a breach of this Agreement.</p>
  </li>
  <li>
    <p><u>Use Restrictions.</u></p>
    <ol>
      <li>
        <p>Licensee shall not directly or indirectly:</p>
        <ol>
          <li>
            <p>use (including make any copies of) the Software beyond the scope of the licence granted under 2;</p>
          </li>
          <li>
            <p>provide any other person, including any subcontractor, independent contractor, affiliate, or service provider of Licensee, with access to or use of the Software;</p>
          </li>
          <li>
            <p>modify, correct, translate, adapt, enhance, further develop, or otherwise create derivative works, enhancements or improvements, whether or not patentable, of the Software or any part thereof;</p>
          </li>
          <li>
            <p>remove, delete, efface, alter, obscure, translate, combine, supplement, or otherwise change any trademarks or any copyright, trademark, patent, or other intellectual property or proprietary rights or other symbols, notices, marks, or serial numbers on or relating to the Software;&nbsp;</p>
          </li>
          <li>
            <p>rent, lease, lend, sell, sublicense, assign, distribute, publish, transfer, or otherwise make available the Software, or any features or functionality of the Software, to any third party for any reason;</p>
          </li>
          <li>
            <p>use the Software in any manner or for any purpose that infringes, misappropriates, or otherwise violates any Intellectual Property Rights or other right of any person, or that violates any applicable law;</p>
          </li>
        </ol>
      </li>
      <li>
        <p><u>No Implied Rights.</u> Except for the limited rights and licences expressly granted under this Agreement, nothing in this Agreement grants, by implication, waiver, estoppel or otherwise, to Licensee or any third party any Intellectual Property Rights or license, nor other right, title, or interest in or to the Software, and Licensor’s Confidential Information.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Responsibility for Use of Software.</u> Licensee is responsible and liable for all uses of the Software through access thereto provided by Licensor, directly or indirectly.&nbsp;</p>
  </li>
  <li>
    <p><u>Collection and Use of Information.</u></p>
    <ol>
      <li>
        <p>Licensee acknowledges that Licensor may, directly or indirectly through the services of Third Parties, collect and store information regarding use of the Software and about equipment on which the Software is installed or through which it otherwise is accessed and used.</p>
      </li>
      <li>
        <p>Licensee agrees that the Licensor may use such information for any purpose related to any use of the Software by Licensee or on Licensee’s equipment.</p>
      </li>
      <li>
        <p>Licensee represents, warrants, and covenants to Licensor that Licensee owns or otherwise has, and will have, the necessary rights and consents in and relating to the information provided to Licensor so that Licensor does not and will not infringe, misappropriate, or otherwise violate any Intellectual Property Rights, or any privacy or other rights of any third party or violate any applicable Law.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Intellectual Property Rights.</u> Licensee acknowledges and agrees that the Software are provided under licence, and not sold, to Licensee. Licensee does not acquire any ownership interest in the Software under this Agreement, or any other rights thereto, other than to use the same in accordance with the licence granted and subject to all terms, conditions, and restrictions under this Agreement. Licensor and its licensors and service providers reserve and shall retain their entire right, title, and interest in and to the Software and all Intellectual Property Rights arising out of or relating to the Software, except as expressly granted to the Licensee in this Agreement. Licensee shall safeguard all Software from infringement, misappropriation, theft, misuse, or unauthorized access. Licensee shall promptly notify Licensor if Licensee becomes aware of any infringement of the Licensor’s Intellectual Property Rights in the Software and fully cooperate with Licensor in any legal action taken by Licensor to enforce its Intellectual Property Rights.&nbsp;</p>
  </li>
  <li>
    <p><u>Confidential Information.&nbsp;</u></p>
    <ol>
      <li>
        <p>In connection with this Agreement, Licensor (as the <b>"Disclosing Party"</b>) may disclose or make available Confidential Information to Licensee (as the <b>"Receiving Party"</b>). Subject to 8.2, <b>"Confidential Information"</b> means information in any form or medium (whether oral, written, electronic, or other) that the Disclosing Party considers confidential or proprietary, including information consisting of or relating to the Disclosing Party’s technology, trade secrets, know-how, business operations, plans, strategies, customers, and pricing, and information with respect to which the Disclosing Party has contractual or other confidentiality obligations, in each case whether or not marked, designated, or otherwise identified as "confidential".</p>
      </li>
      <li>
        <p><u>Exclusions.&nbsp;</u>Confidential Information does not include information that: (a) was rightfully known to the Receiving Party without restriction on use or disclosure prior to such information being disclosed or made available to the Receiving Party in connection with this Agreement; (b) was or becomes generally known by the public other than by the Receiving Party’s or any of its Representatives’ non-compliance with this Agreement; (c) was or is received by the Receiving Party on a non-confidential basis from a third party that was not or is not, at the time of such receipt, under any obligation to maintain its confidentiality; or (d) was or is independently developed by the Receiving Party without reference to or use of any Confidential Information.</p>
      </li>
      <li>
        <p><u>Protection of Confidentiality Information.</u>&nbsp;As a condition to being provided with any disclosure of or access to Confidential Information, the Receiving Party shall:</p>
        <ol>
          <li>
            <p>not access or use Confidential Information other than as necessary to exercise its rights or perform its obligations under and in accordance with this Agreement;</p>
          </li>
          <li>
            <p>except as may be permitted by and subject to its compliance with Section 8.4, not disclose or permit access to Confidential Information other than to its Representatives who: (i) need to know such Confidential Information for purposes of the Receiving Party’s exercise of its rights or performance of its obligations under and in accordance with this Agreement; and (ii) are bound by confidentiality and restricted use obligations at least as protective of the Confidential Information as the terms set forth in this 8.3;</p>
          </li>
          <li>
            <p>safeguard the Confidential Information from unauthorized use, access, or disclosure using at least the degree of care it uses to protect its similarly sensitive information and in no event less than a reasonable degree of care;</p>
          </li>
          <li>
            <p>ensure its Representatives’ compliance with, and be responsible and liable for any of its Representatives’ non-compliance with, the terms of this 8; and</p>
          </li>
          <li>
            <p>promptly notify the Disclosing Party of any unauthorized use or disclosure of the Disclosing Party’s Confidential Information and take all reasonable steps/use its best efforts/cooperate with Disclosing Party to prevent further unauthorized use or disclosure.</p>
          </li>
        </ol>
      </li>
      <li>
        <p><u>Compelled Disclosures.</u> If the Receiving Party or any of its Representatives is compelled by applicable Law to disclose any Confidential Information then, to the extent permitted by applicable Law, the Receiving Party shall: (a) promptly, and prior to such disclosure, notify the Disclosing Party in writing of such requirement so that the Disclosing Party can seek a protective order or other remedy or waive its rights under tion 8.3; and (b) provide reasonable assistance to the Disclosing Party in opposing such disclosure or seeking a protective order or other limitations on disclosure. If the Disclosing Party waives compliance or, after providing the notice and assistance required under this 8.4, the Receiving Party remains required by Law to disclose any Confidential Information, the Receiving Party shall disclose only that portion of the Confidential Information that the Receiving Party is legally required to disclose.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Term and Termination.</u></p>
    <ol>
      <li>
        <p>This Agreement and the licence granted hereunder shall remain in effect until terminated as set forth herein (the <b>"Term"</b>).</p>
      </li>
      <li>
        <p>Licensee may terminate this Agreement by ceasing to use and destroying all copies of the Software.&nbsp;</p>
      </li>
      <li>
        <p>Licensor may terminate this Agreement if Licensee breaches this Agreement and such breach: (i) is incapable of cure; or (ii) being capable of cure, remains uncured seven (7) days after Licensor provides notice thereof.</p>
      </li>
      <li>
        <p>Licensor may terminate this Agreement, effective immediately, if Licensee files an assignment in bankruptcy or has a bankruptcy order made against it under any bankruptcy or insolvency law, makes or seeks to make a general assignment for the benefit of its creditors or applies for, or consents to, the appointment of a trustee, receiver, receiver-manager, monitor, or custodian for all or a substantial part of its property.</p>
      </li>
      <li>
        <p>Upon expiration or earlier termination of this Agreement, the licence granted hereunder shall also terminate, and Licensee shall cease using and destroy all copies of the Software, and permanently erase or cause to be erased from its computer systems, files, and storage media all copies of the Software of Licensor obtained, made or authorized to be made by Licensee or on Licensee’s behalf. No expiration or termination shall affect Licensee’s obligation to pay all Licensee Fees that may have become due before such expiration or termination, or entitle Licensee to any refund.</p>
      </li>
      <li>
        <p>The provisions set forth in the following sections, and any other right or obligation of the parties in this Agreement that, by its nature, should survive termination or expiration of this Agreement, will survive any expiration or termination of this Agreement: 1, 6.2, 7, 8, 9.5, 9.6, section 10, 11 and 13.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Limited Warranties, Exclusive Remedy, and Disclaimer/Warranty Disclaimer.</u></p>
    <ol>
      <li>
        <p>THE SOFTWARE IS PROVIDED TO LICENSEE "AS IS" AND WITH ALL FAULTS AND DEFECTS WITHOUT CONDITION OR WARRANTY OF ANY KIND. TO THE MAXIMUM EXTENT PERMITTED UNDER APPLICABLE LAW, LICENSOR, ON ITS OWN BEHALF AND ON BEHALF OF ITS AFFILIATES AND ITS AND THEIR RESPECTIVE LICENSORS AND SERVICE PROVIDERS, EXPRESSLY DISCLAIMS ALL CONDITIONS AND WARRANTIES, WHETHER EXPRESS, IMPLIED, STATUTORY, OR OTHERWISE, WITH RESPECT TO THE SOFTWARE, INCLUDING ALL IMPLIED CONDITIONS AND WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, QUIET POSSESSION AND NON-INFRINGEMENT, AND WARRANTIES THAT MAY ARISE OUT OF COURSE OF DEALING, COURSE OF PERFORMANCE, USAGE, OR TRADE PRACTICE. WITHOUT LIMITING THE FOREGOING, LICENSOR DOES NOT MAKE ANY REPRESENTATIONS OR WARRANTIES AS TO THE SUITABILITY OF THE INSURANCE INFORMATION DISPLAYED BY LICENSOR’S SOFTWARE, AND LICENSEE AGREES AND ACKNOWLEDGES THAT ALL INSURANCE INFORMATION PROVIDED BY LICENSOR’S SOFTWARE ARE SUBJECT TO APPROVAL AND VERIFICATION BY SUCH INSURANCE PROVIDERS.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Limitation of Liability.</u> TO THE FULLEST EXTENT PERMITTED UNDER APPLICABLE LAW:</p>
    <ol>
      <li>
        <p>IN NO EVENT WILL LICENSOR OR ITS AFFILIATES, OR ANY OF ITS OR THEIR RESPECTIVE LICENSORS OR SERVICE PROVIDERS, BE LIABLE TO LICENSEE OR ANY THIRD PARTY FOR: (a) ANY: (i) USE, INTERRUPTION, DELAY, OR INABILITY TO USE THE SOFTWARE; (ii) LOST REVENUES OR PROFITS; (iii) DELAYS, INTERRUPTION, OR LOSS OF SERVICES, BUSINESS, OR GOODWILL; (iv) LOSS OR CORRUPTION OF DATA; (v) LOSS RESULTING FROM SYSTEM OR SYSTEM SERVICE FAILURE, MALFUNCTION, OR SHUTDOWN; (vi) FAILURE TO ACCURATELY TRANSFER, READ, OR TRANSMIT INFORMATION; (vii) FAILURE TO UPDATE OR PROVIDE CORRECT INFORMATION; (viii) SYSTEM INCOMPATIBILITY OR PROVISION OF INCORRECT COMPATIBILITY INFORMATION; (ix) BREACHES IN SYSTEM SECURITY; OR (b) ANY CONSEQUENTIAL, INCIDENTAL, INDIRECT, SPECIAL, PUNITIVE, OR EXEMPLARY DAMAGES, IN EACH CASE WHETHER ARISING OUT OF OR IN CONNECTION WITH THIS AGREEMENT, BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), OR OTHERWISE, REGARDLESS OF WHETHER SUCH DAMAGES WERE FORESEEABLE AND WHETHER OR NOT THE LICENSOR WAS ADVISED OF THE POSSIBILITY OF SUCH DAMAGES.</p>
      </li>
      <li>
        <p>IN NO EVENT WILL THE COLLECTIVE AGGREGATE LIABILITY OF LICENSOR AND ITS AFFILIATES, INCLUDING ANY OF ITS OR THEIR RESPECTIVE LICENSORS AND SERVICE PROVIDERS, UNDER OR IN CONNECTION WITH THIS AGREEMENT OR ITS SUBJECT MATTER, UNDER ANY LEGAL OR EQUITABLE THEORY, INCLUDING BREACH OF CONTRACT, TORT (INCLUDING NEGLIGENCE), STRICT LIABILITY, AND OTHERWISE, EXCEED THE TOTAL AMOUNT PAID TO THE LICENSOR PURSUANT TO THIS AGREEMENT FOR THE SOFTWARE THAT IS THE SUBJECT OF THE CLAIM.&nbsp;</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Professional Advice Disclaimer.</u>&nbsp;Licensor is not engaged in rendering legal, tax, accounting, insurance or other professional advice. The Software is not intended to be nor authorized for use as a substitute for the knowledge, expertise, skill and judgment of an insurance professional or other professional advisor. If Licensee or its Representatives require expert assistance, they should seek the services of a competent professional. Without limiting the foregoing, it is the express responsibility of Licensee or its Representatives to review and determine the suitability of any output generated from the Services and to consult their own independent professional advisors before using any such output.</p>
  </li>
  <li>
    <p><u>Miscellaneous.</u></p>
    <ol>
      <li>
        <p><u>Governing Law.</u> This Agreement and all related documents, and all matters arising out of or relating to this Agreement, whether sounding in contract, tort, or statute, are governed by, and construed in accordance with, the laws of the Province of Ontario and the federal laws of Canada applicable therein, without giving effect to any choice or conflict of law provision or rule (whether of the Province of Ontario or any other jurisdiction) that would cause the application of the laws of any jurisdiction other than those of the Province of Ontario.&nbsp;</p>
      </li>
      <li>
        <p><u>Choice of Forum.</u> Any legal suit, action, litigation, or proceeding of any kind whatsoever in any way arising out of, from, or relating to this Agreement, the services provided hereunder, and all contemplated transactions, shall be instituted in the courts of the Province of Ontario, and each Party irrevocably submits to the exclusive jurisdiction of such courts in any such suit, action, litigation, or proceeding. Each Party agrees that a final judgment in any such suit, action, litigation, or proceeding is conclusive and may be enforced in other jurisdictions by suit on the judgment or in any other manner provided by law.&nbsp;</p>
      </li>
      <li>
        <p><u>Force Majeure.</u> Licensor will not be responsible or liable to Licensee, or deemed in default or breach hereunder by reason of any failure or delay in the performance of its obligations hereunder where such failure or delay is due to strikes, labour disputes, civil disturbances, riot, rebellion, invasion, hostilities, war, terrorist attack, embargo, natural disaster, epidemics, pandemics, acts of God, flood, tsunami, fire, sabotage, fluctuations or non-availability of electrical power, heat, light, air conditioning or Licensee equipment, loss and destruction of property, or any other circumstances or causes beyond Licensor’s reasonable control.</p>
      </li>
      <li>
        <p><u>Notices.</u> All notices, requests, consents, claims, demands, waivers, and other communications hereunder shall be in writing and shall be deemed to have been given: (i) when delivered by hand (with written confirmation of receipt); (ii) when received by the addressee if sent by a nationally recognized overnight courier (receipt requested); (iii) on the date sent by facsimile or e-mail (with confirmation of transmission) if sent during normal business hours of the recipient, and on the next business day if sent after normal business hours of the recipient; or (iv) on the 3rd day after the date mailed, by certified or registered mail by the Canada Post Corporation, return receipt requested, postage prepaid.&nbsp;</p>
      </li>
      <li>
        <p><u>Entire Agreement.</u> This Agreement constitutes the sole and entire agreement between Licensee and Licensor with respect to the subject matter contained herein, and supersedes all prior and contemporaneous understandings, agreements, representations, and warranties, both written and oral, with respect to such subject matter.&nbsp;</p>
      </li>
      <li>
        <p><u>Assignment.</u> Licensee shall not assign or otherwise transfer any of its rights, or delegate or otherwise transfer any of its obligations or performance, under this Agreement, in each case whether voluntarily, involuntarily, by operation of law or otherwise, without Licensor’s prior written consent, which consent Licensor may give or withhold in its sole discretion. No delegation or other transfer will relieve Licensee of any of its obligations or performance under this Agreement. Any purported assignment, delegation, or transfer in violation of this&nbsp;<a href="https://docs.google.com/document/d/1VAk3SoEFOAhQpmaS89YxLWAf3obtBwZNctLEGBQnRpM/edit#bookmark=id.2lwamvv">Section 13.6</a> is void. Licensor may freely assign or otherwise transfer all or any of its rights, or delegate or otherwise transfer all or any of its obligations or performance under this Agreement without Licensee’s consent. This Agreement is binding upon and enures to the benefit of the parties hereto and their respective permitted successors and assigns.</p>
      </li>
      <li>
        <p><u>Successors and Assigns; No Third-Party Beneficiaries.</u> This Agreement is for the sole benefit of the parties hereto and their respective permitted successors and permitted assigns and nothing herein, express or implied, is intended to or shall confer on any other person any legal or equitable right, benefit, or remedy of any nature whatsoever under or by reason of this Agreement.</p>
      </li>
      <li>
        <p><u>Amendments and Modifications.</u> This Agreement may only be amended, modified, or supplemented by an agreement in writing signed by each party hereto.&nbsp;</p>
      </li>
      <li>
        <p><u>Waiver.</u> No waiver by any party of any of the provisions hereof shall be effective unless explicitly set forth in writing and signed by the party so waiving. Except as otherwise set forth in this Agreement, no failure to exercise, or delay in exercising, any right, remedy, power, or privilege arising from this Agreement shall operate or be construed as a waiver thereof; nor shall any single or partial exercise of any right, remedy, power, or privilege hereunder preclude any other or further exercise thereof or the exercise of any other right, remedy, power, or privilege.</p>
      </li>
      <li>
        <p><u>Severability.</u> If any term or provision of this Agreement is invalid, illegal, or unenforceable in any jurisdiction, such invalidity, illegality, or unenforceability shall not affect any other term or provision of this Agreement or invalidate or render unenforceable such term or provision in any other jurisdiction.</p>
      </li>
      <li>
        <p><u>Interpretation.</u> For purposes of this Agreement, (a) the words "include," "includes," and "including" shall be deemed to be followed by the words "without limitation"; (b) the word "or" is not exclusive; and (c) the words "herein," "hereof," "hereby," "hereto," and "hereunder" refer to this Agreement as a whole. This Agreement shall be construed without regard to any presumption or rule requiring construction or interpretation against the party drafting an instrument or causing any instrument to be drafted. Unless otherwise stated, all dollar amounts referred to in this Agreement are stated in Canadian dollars.</p>
      </li>
      <li>
        <p><u>Headings.</u> The headings in this Agreement are for reference only and do not affect the interpretation of this Agreement.</p>
      </li>
    </ol>
  </li>
</ol>`,
  fr: `<p><b>Contrat de Licence d'Utilisateur Final du Logiciel</b></p>
<p>Ce Contrat de Licence d'Utilisateur Final (le présent <b>"Contrat"</b>) constitue un accord contraignant entre Quotey, Inc. (<b>"Concédant"</b>) et vous, en tant que licencié du Logiciel (<b>"Licencié"</b>).</p>
<p>LE CONCÉDANT FOURNIT LE LOGICIEL UNIQUEMENT CONFORMÉMENT AUX TERMES ET CONDITIONS ÉNONCÉS DANS LE PRÉSENT CONTRAT ET À CONDITION QUE LE LICENCIÉ LES ACCEPTE ET S’Y CONFORME. EN CLIQUANT SUR LE BOUTON "ACCEPTER", VOUS (A) ACCEPTEZ LE PRÉSENT CONTRAT ET CONVENEZ QUE LE LICENCIÉ EST LIÉ LÉGALEMENT PAR SES TERMES ; ET (B) DÉCLAREZ ET GARANTISSEZ QUE : (I) VOUS ÊTES MAJEUR(E) ET POUVEZ CONCLURE UN ACCORD CONTRAIGNANT ; ET (II) SI LE LICENCIÉ EST UNE SOCIÉTÉ, UNE ORGANISATION GOUVERNEMENTALE OU UNE AUTRE ENTITÉ JURIDIQUE, VOUS AVEZ LE DROIT, LE POUVOIR ET L’AUTORITÉ DE CONCLURE LE PRÉSENT CONTRAT AU NOM DU LICENCIÉ ET DE L’ENGAGER À SES TERMES. SI LE LICENCIÉ N’ACCEPTE PAS LES TERMES DU PRÉSENT CONTRAT, LE CONCÉDANT NE CONCÈDE PAS DE LICENCE POUR LE LOGICIEL AU LICENCIÉ ET VOUS NE DEVEZ PAS L’UTILISER.</p>
<p>NONOBSTANT TOUTE DISPOSITION CONTRAIRE DANS LE PRÉSENT CONTRAT OU L’ACCEPTATION PAR VOUS OU PAR LE LICENCIÉ DES TERMES ET CONDITIONS DU PRÉSENT CONTRAT, AUCUNE LICENCE N’EST CONCÉDÉE (QUE CE SOIT EXPRESSÉMENT, IMPLICITEMENT OU AUTREMENT) EN VERTU DU PRÉSENT CONTRAT, ET CE CONTRAT EXCLUT EXPRESSÉMENT TOUT DROIT CONCERNANT TOUT LOGICIEL QUE LE LICENCIÉ N’A PAS ACQUIS LÉGALEMENT OU QUI N’EST PAS UNE COPIE LÉGITIME ET AUTORISÉE DU LOGICIEL DU CONCÉDANT.</p>
<ol>
  <li>
    <p>Définitions. Aux fins du présent Contrat, les termes suivants auront les significations suivantes :</p>
    <ol>
      <li>
        <p><b>"Droits de Propriété Intellectuelle"</b> désigne tous les droits, enregistrés ou non, accordés, sollicités ou autrement existants, actuels ou futurs, en vertu ou en relation avec tout brevet, droit d’auteur, marque, secret commercial, protection des bases de données ou autres lois relatives à la propriété intellectuelle, ainsi que tous droits ou formes de protection similaires ou équivalents, dans le monde entier.</p>
      </li>
      <li>
        <p><b>"Représentant"</b> désigne, pour une partie, ses employés, dirigeants, administrateurs, consultants, agents, contractants indépendants, prestataires de services, sous-licenciés, sous-traitants et conseillers juridiques.&nbsp;</p>
      </li>
      <li>
        <p><b>"Logiciel"</b> désigne les programmes informatiques que le Concédant fournit au Licencié.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Accès et Utilisation.</u> Sous réserve et conditionné par le respect par le Licencié des termes et conditions du présent Contrat, le Concédant accorde au Licencié un droit non exclusif et non transférable d’accéder et d’utiliser le Logiciel pendant la Durée, exclusivement pour l’usage interne du Licencié et conformément aux termes ci‑dessus.</p>
  </li>
  <li>
    <p><u>Matériaux de Tiers.</u> Le Logiciel inclut des logiciels, contenus, données ou autres matériaux, y compris la documentation associée, appartenant à des tiers autres que le Concédant et fournis au Licencié selon des conditions de licence additionnelles et/ou différentes de celles prévues dans le présent Contrat (<b>"Licences de Tiers"</b>). La propriété de tous les Droits de Propriété Intellectuelle relatifs à ces Matériaux de Tiers demeure aux propriétaires respectifs. Le Licencié s’engage à respecter toutes les Licences de Tiers. Toute violation par le Licencié d’une Licence de Tiers constitue également une violation du présent Contrat.</p>
  </li>
  <li>
    <p><u>Restrictions d’Utilisation.</u></p>
    <ol>
      <li>
        <p>Le Licencié ne doit pas, directement ou indirectement :</p>
        <ol>
          <li>
            <p>utiliser (y compris réaliser des copies du) le Logiciel au-delà de la portée de la licence concédée en vertu de la section 2 ;</p>
          </li>
          <li>
            <p>fournir à toute autre personne, y compris tout sous-traitant, contractant indépendant, affilié ou prestataire de services du Licencié, l’accès ou l’utilisation du Logiciel ;</p>
          </li>
          <li>
            <p>modifier, corriger, traduire, adapter, améliorer, développer davantage ou créer autrement des œuvres dérivées, des améliorations ou perfectionnements du Logiciel ou de toute partie de celui‑ci, qu’ils soient brevetables ou non ;</p>
          </li>
          <li>
            <p>retirer, supprimer, effacer, modifier, obscurcir, traduire, combiner, compléter ou modifier toute marque, droit d’auteur, brevet ou autre droit de propriété intellectuelle ou exclusif, ou tout autre symbole, avis, marque ou numéro de série figurant sur ou relatif au Logiciel;&nbsp;</p>
          </li>
          <li>
            <p>louer, prêter, vendre, sous‑licencier, céder, distribuer, publier, transférer ou rendre disponible le Logiciel, ou toute fonctionnalité ou caractéristique du Logiciel, à un tiers pour quelque raison que ce soit ;</p>
          </li>
          <li>
            <p>utiliser le Logiciel de manière ou pour une finalité qui porterait atteinte aux Droits de Propriété Intellectuelle ou à tout autre droit d’une personne, ou qui enfreindrait toute loi applicable ;</p>
          </li>
        </ol>
      </li>
      <li>
        <p><u>Aucun Droit Implicite.</u> À l’exception des droits et licences limités expressément concédés dans le présent Contrat, rien dans celui‑ci n’accorde, par implication, renonciation, estoppel ou autrement, au Licencié ou à un tiers, aucun droit de propriété intellectuelle ou licence, ni aucun autre droit, titre ou intérêt sur ou relatif au Logiciel et aux Informations Confidentielles du Concédant.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Responsabilité de l’Utilisation du Logiciel.</u> Le Licencié est responsable de toute utilisation du Logiciel via l’accès qui lui est fourni par le Concédant, directement ou indirectement.&nbsp;</p>
  </li>
  <li>
    <p><u>Collecte et Utilisation des Informations.</u></p>
    <ol>
      <li>
        <p>Le Licencié reconnaît que le Concédant peut, directement ou indirectement par l’intermédiaire de tiers, collecter et stocker des informations relatives à l’utilisation du Logiciel ainsi qu’aux équipements sur lesquels il est installé ou par lesquels il est utilisé.</p>
      </li>
      <li>
        <p>Le Licencié accepte que le Concédant puisse utiliser ces informations pour toute finalité liée à l’utilisation du Logiciel par le Licencié ou sur ses équipements.</p>
      </li>
      <li>
        <p>Le Licencié déclare, garantit et s’engage auprès du Concédant à détenir, ou à obtenir, les droits et consentements nécessaires relatifs aux informations fournies afin que le Concédant ne viole pas, et ne viole pas ultérieurement, aucun Droit de Propriété Intellectuelle, droit à la vie privée ou autre droit d’un tiers, ni n’enfreigne aucune loi applicable.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Droits de Propriété Intellectuelle.</u> Le Licencié reconnaît et accepte que le Logiciel est fourni sous licence, et non vendu, au Licencié. Le Licencié n’acquiert aucun droit de propriété sur le Logiciel, hormis le droit de l’utiliser conformément à la licence concédée et sous réserve de toutes les conditions, restrictions et modalités prévues dans le présent Contrat. Le Concédant, ainsi que ses concédants et prestataires de services, se réservent et conservent l’intégralité de leurs droits, titres et intérêts relatifs au Logiciel et à tous les Droits de Propriété Intellectuelle y afférents. Le Licencié doit protéger le Logiciel contre toute violation, appropriation illicite, vol, usage abusif ou accès non autorisé, et notifier promptement le Concédant de toute infraction constatée, en coopérant pleinement avec ce dernier pour faire respecter ses droits.</p>
  </li>
  <li>
    <p><u>Informations Confidentielles.&nbsp;</u></p>
    <ol>
      <li>
        <p>Dans le cadre du présent Contrat, le Concédant (en tant que <b>"Partie Divulgatrice"</b>) peut divulguer ou mettre à disposition des Informations Confidentielles au Licencié (en tant que <b>"Partie Réceptrice"</b>). Sous réserve de la section 8.2, <b>"Informations Confidentielles"</b> désigne toute information, sous quelque forme que ce soit (orale, écrite, électronique ou autre), que le Concédant considère comme confidentielle ou exclusive, y compris les informations relatives à sa technologie, ses secrets commerciaux, son savoir‑faire, ses opérations, ses plans, ses stratégies, sa clientèle et ses tarifs, ainsi que toute information faisant l’objet d’obligations contractuelles ou autres de confidentialité, qu’elle soit identifiée ou non comme "confidentielle".</p>
      </li>
      <li>
        <p><u>Exclusions.</u> Les Informations Confidentielles n’incluent pas les informations qui : (a) étaient légitimement connues de la Partie Réceptrice sans restriction d’utilisation ou de divulgation avant leur communication dans le cadre du présent Contrat ; (b) sont ou deviennent accessibles au public autrement que par le non-respect du présent Contrat par la Partie Réceptrice ou ses Représentants ; (c) sont reçues de manière non confidentielle d’un tiers qui n’était pas soumis à une obligation de confidentialité lors de la réception ; ou (d) sont développées de manière indépendante par la Partie Réceptrice sans référence aux Informations Confidentielles.</p>
      </li>
      <li>
        <p><u>Protection des Informations Confidentielles.</u> Pour accéder aux Informations Confidentielles, la Partie Réceptrice devra :</p>
        <ol>
          <li>
            <p>ne pas utiliser les Informations Confidentielles autrement que pour exercer ses droits ou remplir ses obligations en vertu du présent Contrat ;</p>
          </li>
          <li>
            <p>sauf disposition contraire prévue à la section 8.4, ne pas divulguer ou permettre l’accès aux Informations Confidentielles, sauf à ses Représentants ayant besoin d’y accéder pour exécuter les obligations ou exercer les droits prévus par le présent Contrat, et ce, à condition qu’ils soient liés par des obligations de confidentialité au moins équivalentes à celles prévues dans la section 8.3 ;</p>
          </li>
          <li>
            <p>protéger les Informations Confidentielles avec le même degré de soin que celui utilisé pour protéger ses propres informations sensibles, et en aucun cas avec moins qu’un degré raisonnable de précaution ;</p>
          </li>
          <li>
            <p>veiller à ce que ses Représentants respectent ces obligations et être tenu responsable de tout manquement de leur part aux présentes;</p>
          </li>
          <li>
            <p>notifier promptement le Concédant de toute utilisation ou divulgation non autorisée et prendre toutes les mesures raisonnables pour y remédier.</p>
          </li>
        </ol>
      </li>
      <li>
        <p><u>Divulgations Obligatoires.</u> Si la Partie Réceptrice ou l’un de ses Représentants est contraint par la loi de divulguer des Informations Confidentielles, alors, dans la mesure permise par la loi, elle devra : (a) notifier promptement, et avant toute divulgation, le Concédant par écrit afin que celui‑ci puisse demander une mesure de protection ou renoncer à ses droits en vertu de la section 8.3 ; et (b) fournir une assistance raisonnable au Concédant pour contester la divulgation ou obtenir une limitation de celle‑ci. Si le Concédant renonce à l’application de ces dispositions ou si, malgré l’avis et l’assistance fournis conformément à la section 8.4, la loi exige la divulgation de certaines informations, alors seule la portion légalement exigée sera divulguée.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Durée et Résiliation.</u></p>
    <ol>
      <li>
        <p>Le présent Contrat et la licence concédée en vertu des présentes resteront en vigueur jusqu’à leur résiliation telle que prévue (la <b>"Durée"</b>).</p>
      </li>
      <li>
        <p>Le Licencié peut résilier le présent Contrat en cessant d’utiliser et en détruisant toutes les copies du Logiciel.&nbsp;</p>
      </li>
      <li>
        <p>Le Concédant peut résilier le présent Contrat si le Licencié le viole et que cette violation : (i) ne peut être corrigée ; ou (ii) demeure non corrigée sept (7) jours après notification par le Concédant.</p>
      </li>
      <li>
        <p>Le Concédant peut résilier le présent Contrat, avec effet immédiat, si le Licencié déclare faillite, se voit imposer une procédure d’insolvabilité, effectue ou cherche à effectuer une cession générale au profit de ses créanciers, ou consent à la nomination d’un syndic ou d’un administrateur pour une partie substantielle de ses actifs.</p>
      </li>
      <li>
        <p>À l’expiration ou à la résiliation du présent Contrat, la licence concédée prendra fin, et le Licencié devra cesser d’utiliser et détruire toutes les copies du Logiciel, et effacer définitivement de ses systèmes tous les exemplaires obtenus ou réalisés. La résiliation n’affecte pas l’obligation du Licencié de régler les frais dus antérieurement ni ne donne droit à un remboursement.</p>
      </li>
      <li>
        <p>Les dispositions des sections suivantes, ainsi que tout droit ou obligation dont la nature impose leur survie après résiliation, resteront applicables : 1, 6.2, 7, 8, 9.5, 9.6, section 10, 11 et 13.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Garanties Limitées, Recours Exclusif et Clause de Non-responsabilité/Exclusion de Garantie.</u></p>
    <ol>
      <li>
        <p>LE LOGICIEL EST FOURNI AU LICENCIÉ "TEL QUEL" ET AVEC TOUS SES DÉFAUTS, SANS AUCUNE CONDITION NI GARANTIE D’AUCUNE SORTE. DANS LA LIMITE PERMISE PAR LA LOI, LE CONCÉDANT, POUR SON COMPTE ET CELUI DE SES FILIALES, DE SES CONCÉDANTS ET PRESTATAIRES, DÉCLINE EXPRESSÉMENT TOUTES CONDITIONS ET GARANTIES, QU’ELLES SOIENT EXPRESSES, IMPLICITES, STATUTAIRES OU AUTRES, CONCERNANT LE LOGICIEL, Y COMPRIS TOUTES GARANTIES IMPLICITES DE QUALITÉ MARCHANDE, D’ADAPTATION À UN USAGE PARTICULIER, DE TITRE, DE JOUISSANCE PAISIBLE ET DE NON-VIOLATION, AINSI QUE TOUTES GARANTIES QUI POURRAIENT RÉSULTER DES PRATIQUES COMMERCIALES. SANS PRÉJUDICE DE CE QUI PRÉCÈDE, LE CONCÉDANT NE FAIT AUCUNE DÉCLARATION QUE LE LOGICIEL RÉPONDRA AUX EXIGENCES DU LICENCIÉ, OBTIENDRA LES RÉSULTATS SOUHAITÉS, SERA COMPATIBLE AVEC D’AUTRES LOGICIELS, NI NE FONCTIONNERA SANS INTERRUPTION, NI NE SERA PARFAIT, ET TOUTES LES ERREURS POURRONT NE PAS ÊTRE CORRIGÉES.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Limitation de Responsabilité.</u> DANS LA LIMITE MAXIMALE PERMISE PAR LA LOI :</p>
    <ol>
      <li>
        <p>EN AUCUN CAS, LE CONCÉDANT OU SES FILIALES, OU L’UN DE LEURS CONCÉDANTS OU PRESTATAIRES, NE SERONT RESPONSABLES ENVERS LE LICENCIÉ OU UN TIERS DE : (a) TOUT : (i) USAGE, INTERRUPTION, RETARD OU INCAPACITÉ D’UTILISER LE LOGICIEL ; (ii) PERTE DE REVENUS OU DE PROFITS ; (iii) RETARDS, INTERRUPTIONS OU PERTE DE SERVICES, D’AFFAIRES OU DE BONNE VOLONTÉ ; (iv) PERTE OU CORRUPTION DE DONNÉES ; (v) PANNES OU DÉFAILLANCES DU SYSTÈME ; (vi) INCAPACITÉ DE TRANSFÉRER, LIRE OU TRANSMETTRE DES INFORMATIONS ; (vii) INCAPACITÉ DE METTRE À JOUR OU DE FOURNIR DES INFORMATIONS EXACTES ; (viii) INCOMPATIBILITÉ DU SYSTÈME ; (ix) VIOLATION DE LA SÉCURITÉ DU SYSTÈME ; OU (b) TOUT DOMMAGE INDIRECT, ACCESSOIRE, SPÉCIAL, PUNITIF OU EXEMPLAIRE, QUEL QUE SOIT SON ORIGINE, MÊME SI LE CONCÉDANT A ÉTÉ INFORMÉ DE LA POSSIBILITÉ DE TELS DOMMAGES.</p>
      </li>
      <li>
        <p>EN AUCUN CAS, LA RESPONSABILITÉ TOTALE DU CONCÉDANT ET DE SES FILIALES, Y COMPRIS CELLE DE LEURS CONCÉDANTS OU PRESTATAIRES, NE DÉPASSERA LE MONTANT TOTAL PAYÉ AU CONCÉDANT EN VERTU DU PRÉSENT CONTRAT POUR LE LOGICIEL CONCERNÉ.</p>
      </li>
    </ol>
  </li>
  <li>
    <p><u>Avertissement concernant les Conseils Professionnels.</u> Le Concédant ne fournit pas de conseils juridiques, fiscaux, comptables, en assurance ou autres conseils professionnels. Le Logiciel ne doit pas se substituer aux compétences d’un professionnel de l’assurance ou à tout autre conseiller. Si le Licencié ou ses Représentants requièrent une assistance spécialisée, ils doivent consulter un professionnel compétent. Il est de la responsabilité du Licencié de vérifier la pertinence de toute information issue des Services et de consulter ses propres conseillers indépendants avant utilisation.</p>
  </li>
  <li>
    <p><u>Dispositions Diverses.</u></p>
    <ol>
      <li>
        <p><u>Loi Applicable.</u> Le présent Contrat et tous les documents qui y sont liés, ainsi que toute question y afférente, sont régis par les lois de la Province de l’Ontario et les lois fédérales du Canada applicables, sans tenir compte des règles de conflit de lois pouvant imposer l’application des lois d’une autre juridiction.</p>
      </li>
      <li>
        <p><u>Foro Compétent.</u> Tout litige découlant du présent Contrat sera porté devant les tribunaux de la Province de l’Ontario, et chaque partie se soumet irrévocablement à leur compétence exclusive. Un jugement définitif sera contraignant et exécutoire dans toutes juridictions.</p>
      </li>
      <li>
        <p><u>Force Majeure.</u> Le Concédant ne sera pas tenu responsable en cas de manquement ou de retard dans l’exécution de ses obligations dû à des événements hors de son contrôle raisonnable (grèves, troubles, catastrophes naturelles, pandémies, etc.).</p>
      </li>
      <li>
        <p><u>Notifications.</u> Toute notification en vertu du présent Contrat doit être faite par écrit et sera réputée avoir été donnée : (i) lors de la remise en main propre (avec accusé de réception) ; (ii) lors de la réception si envoyée par messagerie reconnue (avec accusé) ; (iii) à la date d’envoi par fax ou e‑mail (avec confirmation) pendant les heures ouvrables, ou le jour ouvrable suivant si envoyée hors heures ouvrables ; ou (iv) le troisième jour après envoi par courrier recommandé prépayé.</p>
      </li>
      <li>
        <p><u>Accord Intégral.</u> Le présent Contrat constitue l’intégralité de l’accord entre le Licencié et le Concédant concernant son objet et remplace toutes communications antérieures, orales ou écrites.</p>
      </li>
      <li>
        <p><u>Cession.</u> Le Licencié ne peut céder ou transférer ses droits ou obligations en vertu du présent Contrat sans le consentement écrit préalable du Concédant (ce consentement pouvant être refusé à sa discrétion). Toute cession non autorisée est nulle. Le Concédant peut céder librement ses droits ou obligations. Le présent Contrat lie les parties ainsi que leurs successeurs autorisés.</p>
      </li>
      <li>
        <p><u>Successeurs et Ayants Droit; Absence de Bénéficiaires Tiers.</u> Ce Contrat profite exclusivement aux parties et à leurs successeurs autorisés, sans conférer de droits à des tiers.</p>
      </li>
      <li>
        <p><u>Amendements et Modifications.</u> Toute modification du présent Contrat doit être faite par écrit et signée par toutes les parties.</p>
      </li>
      <li>
        <p><u>Renonciation.</u> Aucune renonciation à l’une quelconque des dispositions du présent Contrat ne sera effective à moins d’être faite par écrit et signée par la partie concernée. Aucun retard ou défaut d’exercer un droit ne constituera une renonciation.</p>
      </li>
      <li>
        <p><u>Sévérité.</u> Si une disposition du présent Contrat est jugée invalide ou inapplicable, les autres dispositions resteront en vigueur.</p>
      </li>
      <li>
        <p><u>Interprétation.</u> Pour le présent Contrat, (a) les termes "inclure", "inclut" et "y compris" seront interprétés comme suivis de "sans limitation" ; (b) le terme "ou" n’est pas exclusif ; et (c) les termes "ici", "aux présentes", "par les présentes", "ci‑dessus" et "en vertu des présentes" font référence au Contrat dans son ensemble. Sauf indication contraire, tous les montants sont exprimés en dollars canadiens.</p>
      </li>
      <li>
        <p><u>Titres.</u> Les titres des sections sont fournis uniquement à titre indicatif et n’affectent pas l’interprétation du Contrat.</p>
      </li>
    </ol>
  </li>
</ol>`
};

// export const emailBodyBindProspect = {
//   en: `<!DOCTYPE html>
// <html lang="en">
//   <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Bind Request</title>
//     <style>
//       body {
//         font-family: Arial, sans-serif;
//         line-height: 1.6;
//       }
//       .content {
//         margin: 20px;
//       }
//       .highlight {
//         font-weight: bold;
//       }
//     </style>
//   </head>
//   <body>
//     <div class="content">
//       <p>Please find attached a bind request on behalf of <span class="highlight"><<userName>></span> at <span class="highlight"><<insuranceBrokerageName>></span> created on the Quotey platform.</p>
//       <p>All information from the quote and initial client application is attached.</p>
//       <p>Client: <span class="highlight"><<clientName>></span></p>
//       <p>Effective date: <span class="highlight"><<effectiveDate>></span></p>
//       <p>Premium: <span class="highlight"><<premiumValue>></span></p>
//       <p>Insurer Fees: <span class="highlight"><<insurerFeeValue>></span></p>
//       <p>Payment method: <span class="highlight"><<paymentMethod>></span></p>
//       <p><strong>Do not reply to this message - as it is an unattended mailbox. If you have any questions, please contact the submitting insurance broker at <span class="highlight"><<userEmailAddress>></span></strong></p>
//       <p>A copy of this bind request is being sent to the designated insurer email address, and to the insurance broker.</p>
//       <p>Thank you, and congratulations on the bind.</p>
//     </div>
//   </body>
// </html>
// `,
//   fr: `<!DOCTYPE html>
// <html lang="fr">
//   <head>
//     <meta charset="UTF-8">
//     <meta name="viewport" content="width=device-width, initial-scale=1.0">
//     <title>Demande d'engagement</title>
//     <style>
//       body {
//         font-family: Arial, sans-serif;
//         line-height: 1.6;
//       }
//       .content {
//         margin: 20px;
//       }
//       .highlight {
//         font-weight: bold;
//       }
//     </style>
//   </head>
//   <body>
//     <div class="content">
//       <p>Veuillez trouver ci-joint une demande d'engagement au nom de <span class="highlight"><<userName>></span> chez <span class="highlight"><<insuranceBrokerageName>></span> créée sur la plateforme Quotey.</p>
//       <p>Toutes les informations du devis et de la demande initiale du client sont jointes.</p>
//       <p>Client : <span class="highlight"><<clientName>></span></p>
//       <p>Date d'effet : <span class="highlight"><<effectiveDate>></span></p>
//       <p>Prime : <span class="highlight"><<premiumValue>></span></p>
//       <p>Frais de l'assureur : <span class="highlight"><<insurerFeeValue>></span></p>
//       <p>Mode de paiement : <span class="highlight"><<paymentMethod>></span></p>
//       <p><strong>Ne répondez pas à ce message - il provient d'une boîte aux lettres non surveillée. Si vous avez des questions, veuillez contacter le courtier en assurance ayant soumis la demande à <span class="highlight"><<userEmailAddress>></span></strong></p>
//       <p>Une copie de cette demande d'engagement est envoyée à l'adresse e-mail de l'assureur désigné ainsi qu'au courtier en assurance.</p>
//       <p>Merci, et félicitations pour cet engagement.</p>
//     </div>
//   </body>
// </html>
// `
// };

export const emailBodyBindProspect = {
  en: [
    'Please find attached details of a policy bound on behalf of <<userName>> at <<insuranceBrokerageName>> created on the Quotey platform.',
    '',
    'All information from the bindable quote and initial client application is attached.',
    '',
    'Client: <<clientName>>',
    '',
    'Effective date: <<effectiveDate>>',
    '',
    'Premium: <<premiumValue>>',
    '',
    'Insurer Fees: <<insurerFeeValue>>',
    '',
    'Payment method: <<paymentMethod>>',
    '',
    'Do not reply to this message - as it is an unattended mailbox. If you have any questions, please contact the submitting insurance broker at <<userEmailAddress>>',
    'A copy of this bind is being sent to the designated insurer email address, and to the insurance broker.',
    'Thank you, and congratulations on the bind.'
  ].join('\n'),

  fr: [
    "Veuillez trouver ci-joint les détails d'une police souscrite au nom de <<userName>> chez <<insuranceBrokerageName>> créée sur la plateforme Quotey.",
    '',
    "Toutes les informations du devis susceptible de donner lieu à un engagement ainsi que de la demande initiale du client sont jointes.",
    '',
    'Client : <<clientName>>',
    '',
    "Date d'effet : <<effectiveDate>>",
    '',
    'Prime : <<premiumValue>>',
    '',
    "Frais de l'assureur : <<insurerFeeValue>>",
    '',
    'Mode de paiement : <<paymentMethod>>',
    '',
    "Ne répondez pas à ce message - il s'agit d'une boîte aux lettres non surveillée. Si vous avez des questions, veuillez contacter le courtier en assurance ayant soumis la demande à <<userEmailAddress>>",
    "Une copie de cette police souscrite est envoyée à l'adresse e-mail de l'assureur désigné ainsi qu'au courtier en assurance.",
    "Merci, et félicitations pour cette souscription."
  ].join('\n')
};




export const emailBodyBindProspectText = {
  en: [
    'Please find attached details of a quote indication provided on the Quotey platform to <<userName>> at <<insuranceBrokerageName>>.',
    '',
    '<<userName>> has asked that you review and firm up this indication in order to provide formal, bindable terms.',
    '',
    'Client: <<clientName>>',
    '',
    'Effective date: <<effectiveDate>>',
    '',
    'Premium: <<premiumValue>>',
    '',
    'Insurer Fees: <<insurerFeeValue>>',
    '',
    'Payment method: <<paymentMethod>>',
    '',
    'Do not reply to this message - as it is an unattended mailbox. If you have any questions, please contact the submitting insurance broker at <<userEmailAddress>>',
    'A copy of this bind request is being sent to the designated insurer email address, and to the insurance broker.'
    
  ].join('\n'),

  fr: [
    "Veuillez trouver ci-joint les détails d'une indication de devis fournie sur la plateforme Quotey à <<userName>> chez <<insuranceBrokerageName>>.",
    '',
    "<<userName>> vous a demandé de revoir et de finaliser cette indication afin de fournir des conditions formelles et engageantes.",
    '',
    'Client : <<clientName>>',
    '',
    "Date d'effet : <<effectiveDate>>",
    '',
    'Prime : <<premiumValue>>',
    '',
    "Frais de l'assureur : <<insurerFeeValue>>",
    '',
    'Mode de paiement : <<paymentMethod>>',
    '',
    "Ne répondez pas à ce message - il s'agit d'une boîte aux lettres non surveillée. Si vous avez des questions, veuillez contacter le courtier en assurance ayant soumis la demande à <<userEmailAddress>>",
    "Une copie de cette demande d'engagement est envoyée à l'adresse e-mail de l'assureur désigné, ainsi qu'au courtier en assurance."
    
  ].join('\n')
};





export const emailBodyBindLetter = {
  en: `
Hi,

Thank you again for your trust and your business.

Please find attached a letter confirming the key coverages that we have put in place for your business.

We will send your full documents as soon as we receive them.

Thank you, and please let me know if you have any questions.

- <<brokername>>
`,
  fr: `
Bonjour,

Merci encore pour votre confiance et votre collaboration.

Veuillez trouver ci-joint une lettre confirmant les garanties clés que nous avons mises en place pour votre entreprise.

Nous vous enverrons vos documents complets dès que nous les aurons reçus.

Merci, et n'hésitez pas à me contacter si vous avez des questions.

- <<brokername>>
`
};

export const emailBodyCertificate = {
  en: `
Hi,

As requested, please find attached a certificate for your insurance.

Please let me know if there are any issues or if any adjustments are required.

Thank you,

<<brokername>>
`,
  fr: `
Bonjour,

Comme demandé, veuillez trouver ci-joint un certificat pour votre assurance.

Veuillez me faire savoir s'il y a des problèmes ou si des ajustements sont nécessaires.

Merci,

<<brokername>>
`
};


export const emailBodyClientPresentation = {
  en: `Hi,

Please find attached an update document regarding your insurance.

If you have any questions, please reach out at your convenience.

Thank you again for working with us.

<<brokername>>`,
  fr: `Bonjour,

Veuillez trouver ci-joint un document renfermant tous les renseignements concernant votre assurance.

Si vous avez des questions, n'hésitez pas à nous contacter à votre convenance.

Merci encore de travailler avec nous.

<<brokername>>`
};

/// for reminder table
export const WEEK = "week";
export const MONTH = "month";
export const TODAY = "today";
export const YEAR = "year";
export const STATUS_KEY = "status";
export const CREATOR = "creator";
export const START_DATE = "startDate";
export const END_DATE = "endDate";
export const OWNER = "owner";
export const ME = "me";
export const CATEGORY = "category";
export const CUSTOM = "custom";

export const CLIENT = "client";
export const POLICY = "policy";
export const PROSPECT = "prospect";
export const INDIVIDUAL = "individual";
export const GROUP = "group";
export const OTHER = "other";
export const NO_NAME_FOUND = "name not found";
export const TWO_FA_VERIFICATION =
  "Unauthorized. Two factor authentication failed.";
export const OPTION = [
  { value: "individual", label: { en: "Individual", fr: "Individuel" } },
  { value: "group", label: { en: "Group", fr: "Groupe" } },
];
export const clientPolicyProspectGroup = [
  { value: "client", label: { en: "Client", fr: "Client" } },
  { value: "policy", label: { en: "Policy", fr: "Police" } },
  { value: "prospect", label: { en: "Prospect", fr: "Prospect" } },
];
export const statusList = [
  {
    value: "open",
    label: { en: "Open", fr: "Ouvert" },
  },
  {
    value: "completed",
    label: { en: "Completed", fr: "Terminé" },
  },
  {
    value: "onhold",
    label: { en: "On hold", fr: "En attente" },
  },
  {
    value: "other",
    label: { en: "Other", fr: "Autre" },
  },
];

export const statusOptionList = [
  {
    value: "App In Progress",
    label: { en: "App In Progress", fr: "Application en cours" },
  },
  {
    value: "Sold",
    label: { en: "Sold", fr: "Vendu" },
  },
  {
    value: "In Market",
    label: { en: "In Market", fr: "Sur le marché" },
  },
  {
    value: "new",
    label: { en: "New", fr: "Nouveau" },
  },
  {
    value: "Client adjustments",
    label: { en: "Client adjustments", fr: "Ajustements du client" },
  },
];

export const dateOptionList = [
  {
    value: "today",
    label: { en: "Today and Past Due", fr: "Aujourd'hui et en retard" },
  },
  {
    value: "week",
    label: { en: "This Week", fr: "Cette semaine" },
  },
  {
    value: "month",
    label: { en: "This Month", fr: "Ce mois-ci" },
  },
  {
    value: "year",
    label: { en: "This Year", fr: "Cette année" },
  },
  {
    value: "custom",
    label: { en: "Custom", fr: "Personnalisé" },
  },
];

export function getTranslatedOptions(options, langPref) {
  if (Array.isArray(options)) {
    return options.map((option) => ({
      value: option.value,
      label: option.label[langPref] || option.label.en,
    }));
  } else if (typeof options === "object" && options !== null) {
    // Handle single option translation
    return {
      value: options.value,
      label: options.label[langPref] || options.label.en,
    };
  } else {
    return []; // Or handle the error appropriately for your use case
  }
}

export const reminderList = [
  { value: "me", label: { en: "Me", fr: "Moi" } },
  {
    value: "allReminders",
    label: { en: "All Reminders", fr: "Tous les rappels" },
  },
  { value: "myTeam", label: { en: "My Team", fr: "Mon équipe" } },
];
export var PaymentMethodList = [
  {
    value: "Agency Bill",
    label: { en: "Agency Bill", fr: "Facturation d'agence" },
  },
  {
    value: "Direct Bill",
    label: { en: "Direct Bill", fr: "Facturation directe" },
  },
];
export const insurerSelectList = [
  {
    value: "carrierCode",
    label: { en: "Carrier Code", fr: "Code de la compagnie" },
  },
  { value: "mgaCode", label: { en: "MGA Code", fr: "Code MGA" } },
];

export const EXTERNALBINDMSG =
  "Please do not leave this page until bind is confirmed.  This may take up to 30 seconds.  Once confirmed, you'll be automatically taken through to a binder page, and documents will be available";
